import React, { useState, useRef } from 'react'
import Slider from 'react-slick'
import {
  images,
  japanImages,
} from '../../services/images.service'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import dotloader from '../../assets/imgs/dotloader.gif'
import { BlackBlock, ChooseCityBanner } from '../ui/elements/japanguide'
import { ArrowLeft, ArrowRight } from '../ui/icons/shared'

// נתוני הערים – יש להשתמש בנתונים אלו בלבד
const cities = [
  {
    name: 'טוקיו',
    x: '85%',
    y: '50%',
    details:
      'עיר תוססת עם תרבות עשירה, היסטוריה, אטרקציות מגוונות ואוכל מצוין.',
    sections: {
      destinations: {
        heading: 'יעדים בטיול טוקיו',
        description:
          'תמיד שווה ביקור – טוקיו מציעה שפע של אתרים היסטוריים, תרבותיים וטכנולוגיים לצד חוויות מיוחדות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230567/Takeshita-Street_yqzqts.webp',
            title: 'רחוב טקשיטה',
            text: 'הלב הפועם של תרבות הנוער היפנית – רחוב צבעוני ומלא חיים עם חנויות אופנה ייחודיות, ממתקים מוגזמים ודוכני אוכל טרנדים. זה המקום המושלם לחוות את הצד הכיפי והאופנתי של טוקיו.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230568/%D7%9E%D7%A7%D7%93%D7%A9_%D7%A1%D7%A0%D7%A1%D7%95%D7%92%D7%99_ipjxkg.jpg',
            title: "מקדש סנסו-ג'י",
            text: 'המקדש העתיק והמרשים ביותר בטוקיו, מוקף ברחובות מסורתיים ודוכני מזכרות. שער קאמינרימון האייקוני והפנס האדום העצום בכניסה הופכים אותו לאחד מהאתרים המפורסמים והמתויירים בעיר.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233349/1103-0853_imperial-palace-tokyo-japan_ogkhmc.jpg',
            title: 'הארמון הקיסרי של טוקיו',
            text: 'מעונו הרשמי של קיסר יפן, מוקף גנים יפהפיים ותעלות מים. למרות שהכניסה לארמון עצמו מוגבלת, אפשר להנות מטיול רגוע בגני המזרח המטופחים ולחזות בשערים המרשימים ובאווירה המלכותית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230566/miraikan_aofhue.webp',
            title: 'מוזיאון מיראיקאן',
            text: 'המוזיאון הלאומי למדע וחדשנות בטוקיו הוא גן עדן לחובבי טכנולוגיה, רובוטיקה וחלל. עם תצוגות אינטראקטיביות, מפגש עם הרובוט האנושי ASIMO ותערוכות חדשניות, זה מקום מושלם לכל מי שמתעניין בעתיד ובמדע מתקדם.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230569/parkueno_dqzcu6.jpg',
            title: 'פארק אואנו',
            text: 'אחד הפארקים היפים והגדולים בטוקיו, עם מוזיאונים, מקדשים ופינות טבע שליוות בלב העיר. בעונת האביב הוא הופך לאחד מאתרי פריחת הדובדבן הפופולריים ביותר ביפן.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233746/IMG_4687_jwmmcr.webp',
            title: "מוזיאון ג'יבלי",
            text: "חוויה קסומה לכל חובבי האנימציה של סטודיו ג'יבלי, עם תערוכות מרתקות, שחזורי סצנות מסרטים אהובים ודמויות אייקוניות. הביקור בו מרגיש כמו להיכנס לעולם של הייאו מיאזאקי.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230567/animate_nio1ek.webp',
            title: 'אנימייט',
            text: "רשת חנויות ענקית שמתמחה במזכרות ופריטים מבית שונן ג'אמפ, מנגה, אנימה ודמויות פופולריות. כאן אפשר למצוא כל דבר, החל ממוצרי טקסטיל ועד דמויות אקשן, ואפילו חפצים ייחודיים שמיוצרים במיוחד לאוהבי אנימה.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742230567/comiketTOP_u86wid.jpg',
            title: 'קומיק מרקט',
            text: 'אחד האירועים הגדולים ביותר בעולם המנגה והאנימה, שנערך פעמיים בשנה בטוקיו. זהו כנס שבו אמנים עצמאיים מציגים ומוכרים יצירות מקוריות, חובבי אנימה ומנגה נפגשים, ומתחולל בו תערוכה צבעונית של תרבות הפאנדום.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233705/06_01_02_wjx5sn.png',
            title: "אנימה ג'פן",
            text: 'כנס אנימה ענק נוסף בטוקיו, המוקדש לכל עולם האנימה. במהלך האירוע, ניתן להיחשף להקרנות בכורה, לפגוש יוצרי אנימה, להשתתף בפאנלים ולהתעדכן בחדשות האחרונות מעולם האנימה והתרבות היפנית.',
          },
        ],
      },
      food: {
        heading: 'אוכל',
        description:
          'חוויה קולינרית מגוונת עם מאכלים יפניים מסורתיים ומודרניים, המציעה טעמים אותנטיים בכל רחבי העיר.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233878/outdoor-view_gzybew.jpg',
            title: "דוכן הראמן של איצ'יריו",
            text: 'מקום פופולרי במיוחד לאוהבי ראמן, עם מרק עשוי בצורה מושלמת ומנה משתלמת מבחינת מחיר ואיכות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233918/5179187385_7397fa2da3_b_ua9sb7.jpg',
            title: "מסעדת סושי טסוקיג'י סושיקו",
            text: 'אחת ממסעדות הסושי המפורסמות ביותר בטוקיו, שמציעה סושי טרי וטעים ברמה גבוהה מאוד. זה המקום לפסק זמן בסושי המפורסם של העיר.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233956/8758_aphm0e.jpg',
            title: 'רחוב הראמן של תחנת טוקיו',
            text: "במתחם 'ראמן סטריט' שבתחנת טוקיו תמצאו דוכנים המציעים סושי ברמות גבוהות. כל דוכן מגיש סגנון ראמן שונה, אז אפשר למצוא את המנה המתאימה לכל אחד.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742233995/7088_ext_02_3_o7u7o8.jpg',
            title: 'דוכן אוקונומיאקי של סומטארו',
            text: 'דוכן מסורתי לאוקונומיאקי, פנקייק יפני מלוח שניתן להכין בעצמכם על גריל. האוכל כאן אותנטי והחוויה ייחודית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742234053/Tsukiji_g2s4im.jpg',
            title: "שוק האוכל של צוקיג'י",
            text: 'אחד משוקי האוכל הידועים ביותר בטוקיו, עם דוכנים המגישים סושי טרי, מאכלים ים ומטעמים יפניים מובהקים. מקום שמספק חווית אוכל מסורתית וטובה.',
          },
        ],
      },
      nightlife: {
        heading: 'מקומות מסדרות',
        description:
          'אתרים וסצנות מפורסמות מהסדרות בהן טוקיו מופיעה, המשקפות את הפן המודרני והתרבות הפופולרית של העיר.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742234075/nsplsh_36554c7933707875784c38_mv2_d_4997_3084_s_4_2_ln5l1n.jpg',
            title: 'מעבר החצייה של שיבויה',
            text: "אחד המקומות המפורסמים ביותר בטוקיו, בו חוצים אלפי אנשים מכל כיוון בו זמנית, תוך שמירה על סדר מרהיב. שיבויה מציעה חנויות אופנה מגניבות, מרכזי קניות ענקיים, אזור בידור עם בתי קולנוע, מסעדות מגוונות ומועדוני קאראוקֶה. הופיע בהמון סדרות שונות כמו ג'וג'וטסו קאיזן, טוקיו גול, דורארארה, פרסונה 5 ועוד.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742234102/16590064474_e731c81a90_b_v2gdgy.jpg',
            title: "נהר שאקוג'י",
            text: "נהר שאקוג'י - מתוך הסדרה Your Lie In April (השקר שלך באפריל), נהר שקט ויפהפה בצפון-מערב טוקיו, המוקף בטבע ומסלולי הליכה. האזור מציע נופים רגועים, גנים יפניים ואפשרויות לבילוי לצד המים, במיוחד בעונות האביב והסתיו.",
          },
        ],
      },
    },
  },

  {
    name: 'קיוטו',
    x: '40%',
    y: '50%',
    details:
      'עיר עתיקה וקסומה, המשלבת מסורת יפנית עם תרבות מודרנית. קיוטו מתפארת במקדשים היסטוריים, גנים מרהיבים ושווקים תוססים.',
    sections: {
      destinations: {
        heading: 'יעדים בטיול קיוטו',
        description:
          'קיוטו מציעה אתרים היסטוריים ותרבותיים רבים – ממקדשי שינטו ומבנים עתיקים ועד לשווקים ותצפיות טבע מרהיבות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742235984/Fushimi_Inari_Taisha_Torii_Gates_eoafq7.jpg',
            title: 'פושימי אינארי',
            text: 'מקדש שינטו אייקוני עם שדרת אלפי שערי טוריאי אדומים שמטפסים במעלה ההר. זהו אחד המקומות המצולמים ביותר ביפן וחוויה מדהימה לכל מטייל.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236012/Gion-1024x683_vrcbb2.jpg',
            title: 'אזור גיון',
            text: 'חוויית תרבות יפנית מסורתית – רובע הגיישות ההיסטורי של קיוטו, בו ניתן לראות מופעי תרבות מסורתיים, לבקר בבתי תה עתיקים וליהנות מאווירה יפנית אותנטית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236039/KYOTO_FUN_-_GION_S_GAZE_SUNSET_WALK_fg30jx.jpg',
            title: 'אראשיאמה ויער הבמבוק',
            text: 'אזור טבעי יפהפה עם שבילי הליכה בין חורשות במבוק גבוהות, מקדשים מסורתיים ונופים קסומים לאורך נהר ההוזו.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236063/23041765_m-1_vqktl9.jpg',
            title: 'שוק נישיקי',
            text: '"המטבח של קיוטו", רחוב שוק תוסס עם דוכנים שמוכרים מאכלים מקומיים, חטיפים מסורתיים ודגים טריים – חובה לכל חובב אוכל יפני.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236089/nijo-castle-kyoto-japan-975_xmiduc.jpg',
            title: "מצודת ניג'ו",
            text: "ארמון סמוראים מרשים ששימש את שוגונות טוקוגאווה, עם אולמות מצוירים, גנים יפניים מקסימים ורצפות נינג'ה חורקות למניעת התגנבות.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742416928/caption_jmtdnb.jpg',
            title: 'מוזיאון המנגה של קיוטו',
            text: 'מוזיאון ענק שמוקדש כולו לאמנות המנגה, עם אלפי כרכים לקריאה, תערוכות על התפתחות המנגה ביפן ואפילו אמני מנגה שמציירים במקום.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742416969/1728463304-09c2da440656d367facc4ac0c3096345_dw8d4x.webp',
            title: 'חנות אנימייט קיוטו',
            text: "שלוחה של רשת אנימייט הפופולרית, שבה ניתן למצוא מרצ'נדייז, מנגה, פוסטרים, פיגרים ועוד של אנימות פופולריות.",
          },
        ],
      },
      food: {
        heading: 'אוכל בקיוטו',
        description:
          'המטבח של קיוטו מתאפיין בטעמים עדינים ומנות מסורתיות לצד עיצובים מודרניים – חוויה קולינרית אותנטית.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236126/980x587_xfasxx.webp',
            title: 'ראמן איפודו',
            text: 'רשת הראמן המפורסמת שמציעה ציר חזיר עשיר בטעמים, עם טעמים מותאמים לאזור קיוטו. מקום מעולה לחובבי ראמן.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236167/326_017b_pqpipb.jpg',
            title: 'מסעדת קיוטו קייסקי',
            text: 'מסעדות קייסקי הן חווית גורמה יפנית מסורתית עם ארוחות מרובות מנות, המשתמשות במרכיבים עונתיים מוקפדים, והן הדרך המושלמת להכיר את המטבח המקומי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236729/yayoiken-kyoto-joyo_pwapjt.jpg',
            title: 'יאיוי-קן',
            text: 'מסעדת אוכל ביתי יפני במחירים נוחים, עם מנות כמו דגים בגריל, אורז, מיסו וטמפורה, שמספקות ארוחה מסורתית משביעה.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1741872704/placeholder.jpg',
            title: 'דוכן יטאי על נהר הקאמו',
            text: 'בקיץ, על גדות נהר הקאמו מוקמים דוכני אוכל זמניים שמציעים מנות מקומיות כמו יקיטורי, טאקויאקי ומאכלי רחוב יפניים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742237008/photo0jpg_aknyxc.jpg',
            title: "מאצ'ה האוס",
            text: "בית תה מסורתי המתמחה במשקאות קינוחים ומאפים על בסיס מאצ'ה, התה הירוק היפני המפורסם של קיוטו.",
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בקיוטו',
        description:
          'העיר מציעה חוויות בילוי ייחודיות – מבתי קפה נושאיים ועד לאווירה מיוחדת ברחובות ההיסטוריים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236210/popfancy_attackontitan-14_nyeknm.jpg',
            title: "בית הקפה של שינגקי נו קיוג'ין",
            text: 'קפה נושא המעוצב בהשראת סדרות פופולריות, עם עיצוב מודרני שמשלב מסורת יפנית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742236296/2019_03_c001221_n1ne20.jpg',
            title: 'פוקימון סנטר קיוטו',
            text: "חנות וקפה ייחודיים לחובבי פוקימון, עם מרצ'נדייז נדיר ואווירה מהנה.",
          },
        ],
      },
    },
  },
  {
    name: 'נארה',
    x: '50%',
    y: '80%',
    details:
      'עיר היסטורית מוקפת בטבע ונופים מרהיבים, עם אתרים דתיים ותרבותיים מרשימים.',
    sections: {
      destinations: {
        heading: 'יעדים בנארה',
        description:
          'מקומות ללא קשר לאנימה – אתרים היסטוריים ודתיים ייחודיים שמשקפים את העבר של יפן.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742237970/Daibutsu-den_in_Todaiji_Nara01bs3200_knmlrg.jpg',
            title: "מקדש טודאיג'י",
            text: 'אחד המקדשים המרשימים ביפן, שבו שוכן פסל בודהה ענקי בגובה של כ-15 מטרים. המבנה עצמו עצום ומעורר התפעלות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742237996/18001524952_a11998a468_b_cjsxaa.jpg',
            title: 'מקדש קאסוגה טאישה',
            text: 'מקדש שינטו עתיק הידוע בשבילי הפנסים היפים שלו, המעניקים לו אווירה קסומה במיוחד בשעות הערב.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742238331/_big_BF2C2887D9CA930CE7CC357FF6B42056_be0f3p.jpg',
            title: 'הר ווקאקוסה',
            text: 'הר קטן המשקיף על נארה ומציע תצפית מדהימה על העיר, במיוחד בשעות השקיעה.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417056/Edo-Tokyo_Museum_bsmjw6.jpg',
            title: 'איוואטה טוי מוזיאון',
            text: 'מוזיאון קטן ומיוחד עם צעצועים יפניים מסורתיים לצד דמויות אהובות מאנימה, חוויה מהנה לכל גיל.',
          },
        ],
      },
      food: {
        heading: 'אוכל בנארה',
        description: 'חוויית אוכל אותנטית עם מאכלים יפניים מסורתיים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417090/IMG_9331_wmjs0e.jpg',
            title: 'דוכן מיתאראשי דאנגו בפארק נארה',
            text: 'חטיף רחוב יפני קלאסי של כדורי אורז מתוקים בגריל, חם וטעים במיוחד בטיול בפארק.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417111/23041765_m-1_1_ytbdvj.jpg',
            title: 'שוק האוכל של נארה',
            text: 'רחוב עם דוכנים שמציעים מאכלים מקומיים, כולל סושי, טמפורה ומנות ייחודיות לאזור.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בנארה',
        description: 'חוויה ייחודית באווירה תרבותית עם אלמנטים טבעיים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417134/Nara-deer-shikadamari-phenomenon-park-summer-animals-news-1_sd588c.webp',
            title: 'פארק נארה',
            text: 'פארק עצום ומפורסם שבו צבאים מסתובבים בחופשיות בין המבקרים. אפשר להאכיל אותם בעוגיות מיוחדות וליהנות מהאווירה הייחודית של העיר, הפארק הופיע בסדרות רבות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417134/Nara-deer-shikadamari-phenomenon-park-summer-animals-news-1_sd588c.webp',
            title: 'פארק נארה',
            text: 'פארק עצום ומפורסם שבו צבאים מסתובבים בחופשיות בין המבקרים. אפשר להאכיל אותם בעוגיות מיוחדות וליהנות מהאווירה הייחודית של העיר, הפארק הופיע בסדרות רבות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417134/Nara-deer-shikadamari-phenomenon-park-summer-animals-news-1_sd588c.webp',
            title: 'פארק נארה',
            text: 'פארק עצום ומפורסם שבו צבאים מסתובבים בחופשיות בין המבקרים. אפשר להאכיל אותם בעוגיות מיוחדות וליהנות מהאווירה הייחודית של העיר, הפארק הופיע בסדרות רבות.',
          },
        ],
      },
    },
  },

  {
    name: 'אוסאקה',
    x: '35%',
    y: '85%',
    details:
      "עיר תוססת עם שילוב של היסטוריה, תרבות מודרנית ואוכל מעולה, המכונה 'מטבח יפן'.",
    sections: {
      destinations: {
        heading: 'יעדים באוסאקה',
        description:
          'מקומות ללא קשר לאנימה – אתרים היסטוריים ואטרקציות מודרניות בעיר.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417160/8bf2a66bc850615653867aebb013820c-Osaka_Castle_4_gufvjb.avif',
            title: 'טירת אוסאקה',
            text: 'אחד האתרים ההיסטוריים המרשימים בעיר, מוקפת בגנים יפים ואווירה מסורתית. בתקופת פריחת הדובדבן, המקום הופך לעוד יותר קסום.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417182/dotonburi_bvpbuy.jpg',
            title: 'רחוב דוטונבורי',
            text: "הלב הפועם של אוסאקה עם שלטי ניאון אייקוניים, מסעדות רחוב מעולות ואווירה תוססת שממחישה למה העיר מכונה 'מטבח יפן'.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417205/14c243d3ce6cd216d14558e77e0bde13d41ec265_a93gnf.jpg',
            title: 'אקווריום קאיוקאן',
            text: 'אחד האקווריומים הגדולים והמרשימים בעולם, עם מגוון עצום של יצורי ים, כולל כרישי לוויתן מרשימים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417225/mv_bg01_nwbe1t.avif',
            title: 'גורד השחקים אומדה סקיי',
            text: 'נקודת תצפית מרהיבה על העיר עם רצפת זכוכית שמוסיפה חוויה עוצרת נשימה, במיוחד בלילה.',
          },
        ],
      },
      food: {
        heading: 'אוכל באוסאקה',
        description:
          'חוויה קולינרית עשירה עם מאכלי רחוב יפניים מסורתיים ומסעדות גורמה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417437/dotonbori-guide_4_wypah8.jpg',
            title: 'דוטונבורי',
            text: 'הרחוב המפורסם עם דוכני אוכל רחוב כמו טקויאקי (כדורי תמנון) ואוקונומיאקי (פנקייק יפני מלוח), חובה לכל חובב אוכל יפני.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417279/l2m-jp-1911-ichiran-11_hzobp2.webp',
            title: "מסעדת איצ'יראן ראמן",
            text: 'רשת הראמן הפופולרית שמציעה חוויית אכילה ייחודית בתאים פרטיים, עם מרק טונקוטסו אגדי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417358/imrs_dhfnkl.webp',
            title: 'קיומי סושי',
            text: 'מסעדת סושי איכותית באוסאקה, המגישה דגים טריים ואורז מתובל באופן מושלם.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417416/Kuromon-market.jpg_r7herw.webp',
            title: 'שוק קורומון',
            text: 'מקום נהדר לטעום אוכל רחוב מקומי, כולל פירות ים טריים, שיפודים על הגריל ומנות מיוחדות של אזור קנסאי.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי באוסאקה',
        description:
          'אווירת העיר מתבטאת באטרקציות תרבותיות וסצנות שמופיעות בסדרות אנימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742417437/dotonbori-guide_4_wypah8.jpg',
            title: 'דוטונבורי',
            text: "הרחוב המפורסם, שהופיע בסדרות כמו 'Detective Conan', 'Magic Kaito 1412' ו-'Gantz', ונחשב לאחד הסמלים של אוסאקה.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1741872704/placeholder.jpg',
            title: 'טירת אוסאקה',
            text: "הופיעה בסדרות כמו 'Samurai Champloo', 'Detective Conan' ו-'Teppen', ומהווה רקע לאירועים שונים באנימה.",
          },
          {
            image:
              'https://res-1.cloudinary.com/jnto/image/upload/w_2064,h_1300,c_fill,f_auto,fl_lossy,q_auto/v1517778153/osaka/29718423',
            title: 'תחנת אוסאקה',
            text: "הופיעה בסדרות כמו 'Steins;Gate 0' ו-'Chihayafuru', מקום שוקק חיים עם סצנות מעבר ודיאלוגים חשובים.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465006/osaka-osaka-aquarium-kaiyukan-206669_tydb2e.jpg',
            title: 'אקווריום קאיוקאן',
            text: "הופיע בסדרות כמו 'Free!' ו-'Tsuritama', ומציג את הטבע הימי של האוקיינוס השקט במיכל ענק.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465097/Japan_Pics_2811_15_i_xhqsrg.jpg',
            title: 'טסוטנקאקו',
            text: 'המגדל האיקוני באזור שינסקאי, שהופיע בסדרות אנימה ומשקף את האווירה הרטרו של אוסאקה.',
          },
        ],
      },
    },
  },
  {
    name: 'הירושימה',
    x: '10%',
    y: '65%',
    details:
      'עיר עם היסטוריה עמוקה של תקופות קשות והתחדשות, המציעה אתרי זיכרון, גנים מטופחים ומטבח יפני מעודן.',
    sections: {
      destinations: {
        heading: 'יעדים בטיול הירושימה',
        description:
          'מהפארק השקט ועד לאתרים היסטוריים ששוחזרו בקפידה – הירושימה משלבת זיכרון היסטורי עם יופי טבעי.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465137/M_01457_001_poz6vu.jpg',
            title: 'פארק השלום של הירושימה',
            text: 'אתר זיכרון מרכזי עם אנדרטאות ומוזיאון הממחיש את השפעות התקיפה הגרעינית והתקופה שלאחריה.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465167/aflo_WYTA007470_qvdpt8.jpg',
            title: 'הארמון ההיסטורי',
            text: 'מבנה יפהפה ששוחזר לאחר ההרס במלחמה, המעניק הצצה לתקופות שונות בהיסטוריה של העיר.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465204/c70aa7ff9408b66e4f6fc0252d44514f_lhjmyq.jpg',
            title: 'הגן הבוטני של הירושימה',
            text: 'גן מטופח ויפהפה, מושלם למי שמעוניין לברוח מהעיר הסואנת וליהנות מנוף טבעי מרהיב.',
          },
        ],
      },
      food: {
        heading: 'אוכל בהירושימה',
        description:
          'מטבח הירושימה משלב בין מאכלים מקומיים אותנטיים למנות חדשניות – חוויה קולינרית עשירה ומגוונת.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465251/pancake-blog-header-image-1570px_vy9pfd.jpg',
            title: 'אוקונומיאקי של הירושימה',
            text: 'פנקייק יפני מלוח עם תוספות מגוונות, אחד המאכלים המפורסמים בעיר.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465368/2264736728_c4d2c980fe_b_ym0nz3.jpg',
            title: 'דוכן טמפורה בקורומון',
            text: 'טמפורה קריספית המוגשת עם דגים וירקות, מושלמת כחטיף רחוב.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בהירושימה',
        description:
          'אווירת העיר בשעות הערב מתבטאת במוקדי בילוי עם אווירה תרבותית וייחודית.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465513/4462067_m_kk76wj.jpg',
            title: 'תחנת הירושימה',
            text: "תחנה מרכזית שהופיעה בסדרות כמו 'Steins;Gate', ומהווה נקודת מעבר וקישור בין חלקי העיר.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465481/miyajima-10_iczdsc.png',
            title: "חוף מיאג'ימה",
            text: "אי יפהפה עם שער איטסוקושימה הצף, שהופיע בסדרות כמו 'Monogatari' ו-'Your Name', ומהווה סמל לאזור.",
          },
        ],
      },
    },
  },

  {
    name: 'אוקינאווה',
    x: '30%',
    y: '95%',
    details:
      'אי טרופי עם תרבות ייחודית, שמשלב נופים טבעיים מרהיבים, אתרים היסטוריים וחוויות אנימה ייחודיות.',
    sections: {
      destinations: {
        heading: 'יעדים בטיול אוקינאווה',
        description:
          'אוקינאווה מציעה חוויות מגוונות – מטירות היסטוריות ונופים פנורמיים ועד למוזיאונים וגישות טבע קסומות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465554/Shuri-Castle-Lead-_tdvo8a.jpg',
            title: 'טירת שורי',
            text: 'אתר היסטורי מרהיב המשקיף על העיר והים, משוחזר בקפידה לאחר מלחמת העולם השנייה.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465590/AF1QipMk-CQo8tdBeOvwycQ7xP9fjZvehJBR2HtBXFo2_s1600-k-no_nl6c2r.webp',
            title: 'חוף קוקי',
            text: 'חוף טרופי עם חול לבן ומים צלולים – מקום אידיאלי לרגיעה, שחייה ושנורקלינג.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465619/caption_w37jpv.jpg',
            title: 'המוזיאון הלאומי של אוקינאווה',
            text: 'מוזיאון המציג את ההיסטוריה, התרבות והאמנות של האי, עם תערוכות המדגישות את החיים והמורשת המקומית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465641/ev157_02_southeast-botanical-gardens-illumination_fxahfa.webp',
            title: 'הגן הבוטני של אוקינאווה',
            text: 'גן טבעי עם מגוון צמחים טרופיים ועצים נדירים, מושלם לטיול רגוע בין טבע יפני ייחודי.',
          },
        ],
      },
      food: {
        heading: 'אוכל באוקינאווה',
        description:
          'המטבח של אוקינאווה מתאפיין במנות טרופיות ומקומיות, עם דגש על מאכלי ים וראמן ייחודי.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465869/local_okinawa-soba_pic01_bfwlr4.jpg',
            title: 'סובה אוקינאווית',
            text: 'ראמן עם מרק עוף סמיך, נודלס דקיקים ותוספות כמו חזיר, ביצה ורוטב סויה – אחת התשובות המקומיות לראמן הפופולרי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465899/content_yxnkqn.jpg',
            title: 'דוכן טאקויאקי',
            text: 'כדורי טמפורה עם דגים ורטבים, נשנוש רחוב פופולרי באי.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי באוקינאווה',
        description:
          'אווירת הלילה באוקינאווה משלבת היסטוריה, תרבות ואווירה רגועה עם נגיעות מודרניות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742465928/naha-shuri-castle_zqqarg.jpg',
            title: 'טירת טורי',
            text: 'אתר היסטורי שהופיע באנימה כמו Digimon Adventure tri, המשדר אווירה תרבותית עשירה.',
          },

          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466011/mihama_hqcpqf.jpg',
            title: 'אזור האמריקאי',
            text: 'אזור מסחרי ובילוי פופולרי עם ברים, מסעדות וקניות בסגנון אמריקאי מודרני, המעניק חוויה ייחודית באוקינאווה.',
          },
        ],
      },
    },
  },
  {
    name: 'סאפורו',
    x: '50%',
    y: '20%',
    details:
      'העיר הגדולה ביותר בהוקאידו, ידועה בפארק אודורי ובפסטיבל השלג המפורסם.',
    sections: {
      destinations: {
        heading: 'יעדים בסאפורו',
        description:
          'סאפורו מציעה אתרי טבע, היסטוריה ואטרקציות תרבותיות מרשימות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466046/126A7399-scaled_oswdlk.jpg',
            title: 'פארק אודורי',
            text: 'הלב הפועם של סאפורו – רצועת ירק במרכז העיר עם מזרקות, פרחים ואווירה נעימה; בחורף המקום מתמלא בפסטיבל השלג.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466075/hokkaido-sapporo-tv-tower-215380_qcfmma.jpg',
            title: 'מגדל הטלוויזיה של סאפורו',
            text: 'מגדל תצפית איקוני עם נוף פנורמי מרהיב של העיר, במיוחד בשעות הערב כשהאורות מנצנצים מסביב.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466102/5310_12_hxqoav.jpg',
            title: "שוק ניג'ו",
            text: 'שוק מקומי תוסס עם מאכלי ים טריים, סושי איכותי ומנות ייחודיות לחבל הוקאידו.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466136/10008_4_l_c0bts6.jpg',
            title: 'הר מואיווה',
            text: 'הר נופי עם רכבל לתצפית מרהיבה, במיוחד בלילות כשסאפורו זוהרת.',
          },
        ],
      },
      food: {
        heading: 'אוכל בסאפורו',
        description:
          'מטבח סאפורו מציע מנות ייחודיות וטעמים מקומיים עם דגש על ראמן ומאכלי ים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466178/IMG_1707_scwkua.webp',
            title: 'ראמן מיסו של סאפורו',
            text: 'מנת הדגל של העיר עם ציר מיסו עשיר, חמאה ותירס מקומי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466208/IMG_0431_tiz1ju.webp',
            title: "גריל ג'ינגיס-קאן",
            text: 'מאכל כבש צלוי על גריל אישי עם ירקות ורוטב מיוחד.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466233/hokkaido-milk-ice-cream-a-supreme-delight-recommended-for-travelers-from-singapore-854002_g93o8m.webp',
            title: 'גלידת חלב הוקאידו',
            text: 'גלידה קרמית וטעימה, המיוצרת מחלב איכותי מהאזור.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466262/spot_tanukikoji-2-1600x1067_dittjq.jpg',
            title: "שוק האוכל של טנוקיקוג'י",
            text: 'מתחם אוכל רחוב עם מאכלי ים טריים ומתוקים יפניים.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בסאפורו',
        description:
          'אווירת הלילה בסאפורו מתבטאת באטרקציות תרבותיות ואירועי אנימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466295/spot_sapporo-3-800x534_m1evow.jpg',
            title: 'תחנת סאפורו',
            text: "הופיעה בסדרות כמו 'Your Name' ו-'Vivy: Fluorite Eye’s Song', ומהווה נקודת מעבר מרכזית.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466334/sapporo-beer-garden-2_q50xkq.jpg',
            title: 'מוזיאון הבירה של סאפורו',
            text: "מוזיאון הממחיש את ההיסטוריה של הבירה היפנית, עם אזכורים בסדרות כמו 'Bartender' ו-'Golden Kamuy'.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466415/5305_11_ndbu4d.jpg',
            title: 'שכונת סוסקונו',
            text: 'אזור תוסס עם מגוון ברים, מסעדות וחוויות בילוי, המרכז את חיי הלילה של סאפורו.',
          },
        ],
      },
    },
  },
  {
    name: 'הוקאידו',
    x: '56%',
    y: '8%',
    details:
      'אזור טבע פראי עם נופים הרריים, מעיינות חמים ואטרקציות טבעיות מדהימות.',
    sections: {
      destinations: {
        heading: 'יעדים בהוקאידו',
        description: 'הוקאידו מציעה טבע פראי, פארקים לאומיים ונופים מרהיבים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466459/daisetsuzan-national_leldx5.jpg',
            title: 'הפארק הלאומי דייסטסוזאן',
            text: 'הפארק הגדול ביותר ביפן עם נופים הרריים מרהיבים, מעיינות חמים, וטיולים מושלמים בטבע הפראי של הוקאידו.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466487/top-mv-1_kzrmvq.webp',
            title: 'האקודאטה',
            text: 'עיר נמל יפהפייה בדרום הוקאידו, המפורסמת בנוף הלילה המרהיב מהר האקודאטה ובשוק הבוקר התוסס שלה עם דוכני פירות ים טריים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466518/Sapporo_Snow_Festival_Anya-jpg_pnqdh0.webp',
            title: 'פסטיבל השלג של סאפורו',
            text: 'אחד הפסטיבלים החורפיים המפורסמים בעולם, עם פסלי שלג ענקיים, מופעי אור ומגלשות קרח.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466542/shutterstock_1033353694_pzjpl1.jpg',
            title: 'בייאי ופוראנו',
            text: 'אזורים כפריים עם שדות פרחים צבעוניים בקיץ, במיוחד שדות לבנדר של פוראנו, שהופכים למוקד תיירותי.',
          },
        ],
      },
      food: {
        heading: 'אוכל בהוקאידו',
        description:
          'המטבח האוקאידי מתאפיין במנות ים טריות, מוצרי חלב איכותיים ומנות אותנטיות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466585/recipehokkaido-style-miso-ramen_mdvldr.webp',
            title: 'ראמן מיסו של הוקאידו',
            text: 'גרסה ייחודית של ראמן עם ציר מיסו עשיר ותוספות כמו חמאה ותירס, שנחשב לאחד הטובים ביפן.',
          },

          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466640/hakodate-daimon-yokocyou_rzrsak.jpg',
            title: 'שוק האוכל של האקודאטה',
            text: 'מתחם מושלם לטעימת אוכל מקומי, כולל מרקי מאכלי ים ייחודיים, סרטנים גדולים ומנות דגים טריים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466683/hokkaidosnowsports.com_-600x450_zhqwnb.jpg',
            title: 'מוצרי החלב של הוקאידו',
            text: 'המטבח מתאפיין גם במוצרי חלב איכותיים, כולל גלידות קרמיות, גבינות טובות ומתוקים עשירים המיוצרים מחלב מקומי.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בהוקאידו',
        description:
          'האווירה הלילית באזור משולבת בין אירועי קוספליי ונופים עירוניים מרהיבים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466805/4350_2318_mbjvdl.jpg',
            title: 'פסטיבל השלג של הוקאידו',
            text: "הופיע בסדרות כמו 'Clannad: After Story' ו-'White Album 2', עם פסלי קרח עצומים ומהווה רקע לרגעים דרמטיים ורומנטיים.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466487/top-mv-1_kzrmvq.webp',
            title: 'האקודאטה',
            text: "עיר נמלית עם נוף לילי מרהיב, כפי שנצפה בסדרות כמו 'Love Live! Sunshine!!' ו-'Hakuouki', עם אווירה נוסטלגית ורומנטית.",
          },
        ],
      },
    },
  },
  {
    name: 'שירקאווה-גו',
    x: '50%',
    y: '40%',
    details:
      'כפר מסורתי עם בתים גג משולשים בסגנון גאשו-זוקורי, המעניק תחושה מהאגדות, במיוחד בחורף עם שלג.',
    sections: {
      destinations: {
        heading: 'יעדים בשירקאווה-גו',
        description: 'כפר אותנטי עם נופים כפריים והיסטוריה עשירה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466899/shirakawago-8_r9w2je.webp',
            title: 'כפר שירקאווה-גו',
            text: 'כפר מסורתי עם בתים גג משולשים בסגנון גאשו-זוקורי, מהמם במיוחד בחורף כשהשלג מכסה אותו.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466925/Tourist-looking-Japanese-village-from-Shirakawago-Shiroyama-Observatory-Deck_r2j0di.jpg',
            title: 'מצפה שירקאווה-גו',
            text: 'נקודת תצפית מרהיבה על הכפר והנוף ההררי הסובב.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742466952/1079x715_ea1e9d427fb5664c32c517a73e421e58_e406527010d497cdd0c147d88d0dfc5c34816f76_lchtmv.jpg',
            title: 'מוזיאון הכפר הפתוח',
            text: 'שחזור של כפר מסורתי המדגים את חיי המקומיים בעבר, כולל טחנות מים, בתים משומרים ושדות אורז.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467011/500649-shirakawa-hachiman-shrine-festival-hall_roqt33.avif',
            title: "מקדש שירקאווה האצ'ימאן",
            text: 'מקדש קטן ועתיק בלב הכפר, שמוסיף לאווירה הכפרית המסורתית והשלווה של האזור.',
          },
        ],
      },
      food: {
        heading: 'אוכל בשירקאווה-גו',
        description:
          'המטבח המקומי משלב טעמים כפריים עם מסורת קולינרית ייחודית.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467042/bfd8d05a-specials-hida-beef_list_w0x2ca.jpg',
            title: 'הידה גיואו',
            text: 'בשר בקר מקומי באיכות גבוהה, בדומה לווגיו, שנחשב למעדן ייחודי של האזור.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467063/ND-Mochi-hkpl-superJumbo_ibfxgw.jpg',
            title: "מוצ'י מסורתי",
            text: 'כדורי אורז דביקים עם טעמים משתנים, קינוח פופולרי במיוחד בימים קרים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467085/Sake-japonski-alkohol-ryzowy_x0maxa.webp',
            title: 'סאקה מקומי',
            text: 'יקבים קטנים המייצרים סאקה ייחודי, המשתלב היטב עם המנות המקומיות.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בשירקאווה-גו',
        description: 'אווירה כפרית ונוסטלגית שמשולבת בסצנות אנימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467111/img_shogawa_szojeh.jpg',
            title: 'נהר שוגאווה',
            text: "נהר השוצץ את האזור, מופיע בסדרות כמו 'Higurashi no Naku Koro ni' עם אווירה דרמטית.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467261/hig04_hegphn.jpg',
            title: 'עיירה שירקאווה-גו',
            text: 'העיירה שהייתה השראה להינאמיזאווה הבדיונית, עם בתי גג משולשים ונופים כפריים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467324/7c47e109-309200117_5816907011677383_6642546564110232997_n_kp8cfx.jpg',
            title: 'פסטיבל האורות',
            text: 'אירוע עונתי בכפר, בו מתעוררים הבתים המסורתיים באור קסום, ומעניקים חוויה ייחודית המשלבת מסורת עם מודרניות.',
          },
        ],
      },
    },
  },

  {
    name: 'ניקו',
    x: '85%',
    y: '40%',
    details:
      'עיר היסטורית מוקפת בטבע ונופים מרהיבים, עם אתרים דתיים ותרבותיים מרשימים.',
    sections: {
      destinations: {
        heading: 'יעדים בניקו',
        description: 'ניקו משלבת אתרי דת, היסטוריה ונופים טבעיים עוצרי נשימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467350/3801_topb_gt6mkq.jpg',
            title: 'מקדש טושוגו',
            text: 'אחד המקדשים המרשימים ביפן, מקום קבורתו של השוגון טוקוגאווה איאיאסו, עם עיטורים מפוארים ופסלי שלושת הקופים החכמים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467374/3812_top_uzsmqn.jpg',
            title: 'מפלי קגון',
            text: 'אחד המפלים היפים ביותר ביפן, עם זרימה עוצמתית מגובה של כ-97 מטרים, במיוחד בסתיו כשהעצים סביבם נצבעים באדום וזהב.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467398/3806_top_lfciah.jpg',
            title: "אגם צ'וזנג'י",
            text: 'אגם ציורי בלב ההרים, מושלם לטיולים רגועים או שייט עם נוף של טבע בתולי מסביב.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467436/img_dis_his-nat_07_usd6yo.jpg',
            title: 'הפארק הלאומי של ניקו',
            text: 'אזור טבע פראי עם מסלולי טיול, חיות בר ונוף כפרי מרהיב של יפן הכפרית.',
          },
        ],
      },
      food: {
        heading: 'אוכל בניקו',
        description:
          'המטבח בניקו מתאפיין במנות מסורתיות עם טעמים ייחודיים מהאזור.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467459/what-is-yuba_bwygkt.jpg',
            title: 'יובה (עור טופו)',
            text: 'מאכל מסורתי של ניקו, טופו שמוגש בצורות שונות ונחשב למעדן בריא ואיכותי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467484/4184871_m_fkrfym.jpg',
            title: "מיווג'י מאנצ'ו",
            text: 'כיסוני בצק ממולאים במשחה מתוקה של שעועית אדומה – קינוח פופולרי במיוחד באזור המקדשים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467554/sake_drxetc.webp',
            title: 'סאקה מקומי',
            text: 'יקבים קטנים המייצרים סאקה בטעמים ייחודיים בשל האקלים הקריר של האזור.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בניקו',
        description:
          'אווירת ניקו מתבטאת בשילוב בין היסטוריה, טבע ואירועים תרבותיים.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467580/Toshogu-Shrine-Nikko-1_Aimee-Gardner-1024x600_wdz7mo.jpg',
            title: 'השראה לעולמות פנטזיה',
            text: 'היערות, המקדשים והמפלים בניקו משמשים השראה לרקעים באנימה עם אלמנטים מיתולוגיים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467613/hq720_ug9bk1.jpg',
            title: 'קשר ל-Rurouni Kenshin',
            text: "ניקו מופיעה בסרטי לייב-אקשן של 'רורואוני קנשין', והעיר העתיקה מעניקה אווירה אותנטית לתקופת הסמוראים.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467637/sakuraco_futarasan-shrine_y2wnyi.webp',
            title: 'המקדשים ברוח אנימה',
            text: 'מבנים כמו טושוגו משתלבים היטב עם הסגנון החזותי של סדרות היסטוריות ואנימה עם אלמנטים מיסטיים.',
          },
        ],
      },
    },
  },
  {
    name: 'הקונה',
    x: '70%',
    y: '75%',
    details:
      "עיר עם נופים עוצרי נשימה של הר פוג'י, אגם אשי ומעיינות חמים, המציעה חוויית אונסן אותנטית.",
    sections: {
      destinations: {
        heading: 'יעדים בהקונה',
        description:
          "הקונה מתאפיינת בנופים טבעיים עוצרי נשימה ונקודות תצפית על הר פוג'י.",
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467687/fuji-san-and-lake_vprs9k.jpg',
            title: "הר פוג'י",
            text: 'אחד הנופים האייקוניים ביפן, עם נקודות תצפית מושלמות בימים בהירים.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467716/shutterstock_1303030627_ngkrlq.webp',
            title: 'אגם אשי',
            text: "אגם ציורי עם מים צלולים, המציע שייט ונופים מרהיבים של הר פוג'י.",
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467742/content_1_aruyvd.jpg',
            title: 'עמק אוואקודאני',
            text: 'אזור געשי עם מעיינות חמים ואדים, מפורסם בביצים השחורות שמתבשלים במי הגופרית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467782/Mori-no-Yu-Area-for-Traditional-Japanese-Onsen_ri1xda.png',
            title: 'מעיינות חמים (אונסן)',
            text: 'מעיינות טבעיים עם ריוקנים שמציעים חוויית רחצה מסורתית מרגיעה.',
          },
        ],
      },
      food: {
        heading: 'אוכל בהקונה',
        description:
          'המטבח בהקונה מתאפיין במנות מסורתיות עם מתכונים ייחודיים מהאזור.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467814/oeuf-noir-int%C3%A9rieur_mlpz8p.jpg',
            title: 'ביצי אוואקודאני',
            text: 'ביצים שהתבשלו במעיינות הגופרית, עם קליפה שחורה וטעם ייחודי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467836/19COOKING-SOBANOODLES1-googleFourByThree-v2_fdal5l.jpg',
            title: 'סובה חמה או קרה',
            text: 'אטריות כוסמת טריות המוגשות במסעדות מקומיות בגרסאות שונות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467869/Honey_Castella_Pudding_Cake00002-1200x675_ts4qkj.jpg',
            title: 'קסטלה פודינג',
            text: 'קינוח פופולרי עם מרקם רך וטעם עשיר של קרמל, נמכר בדוכנים סביב תחנות רכבל ואגמים.',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בהקונה',
        description:
          'האווירה בלילה בהקונה משלבת נופים קסומים עם אווירה רגועה ובילויים בסגנון אנימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467895/fuji-hakone-izu_shiraito_falls_102_svbfph_uw2wmg.jpg',
            title: 'נופי הקונה והשראתם',
            text: 'אגמים, הרים ויערות באזור מופיעים ברקעים של סדרות אנימה רבות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467926/laidback-camp-6_skwht9.png',
            title: 'הקונה כיעד חופשה באנימה',
            text: 'דמויות בסדרות יוצאות לטיולי אונסן, מה שהופך את המקום למוכר לחובבי אנימה.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742467953/11a8a8c849a4efd861190570e022a4b54d7c0814_v3fjck.jpg',
            title: 'אוואקודאני במנגה ואנימה',
            text: 'העמק הגעשי עם אווירה דרמטית מופיע בסדרות המתמקדות בטבע יפני, מסתורין ואפילו מדע בדיוני.',
          },
        ],
      },
    },
  },
  {
    name: 'קאנאזאווה',
    x: '25%',
    y: '55%',
    details:
      'עיר עם מורשת עשירה, גנים מעוצבים ושווקים מסורתיים, המשמשת השראה בסדרות ומנגות.',
    sections: {
      destinations: {
        heading: 'יעדים בקאנאזאווה',
        description:
          'קאנאזאווה מציעה חוויות תרבותיות, היסטוריות ואמנותיות עם נוף מסורתי מרהיב.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468078/img_ninomaru_index_cptiit.png',
            title: "רובע הסמוראים נונג'ו",
            text: 'אזור היסטורי עם בתים ישנים של סמוראים, המספק חוויית טיול אותנטית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468105/21CMCA_1024-1024x576_hjw4v2.jpg',
            title: 'מוזיאון האומנות של קאנאזאווה',
            text: 'מוזיאון מודרני המציג יצירות עכשוויות ויפניות, מוקד לאוהבי האמנות.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468132/10030_1_m_pxu5xx.jpg',
            title: 'שוק אומה',
            text: 'שוק תוסס עם מגוון רחב של מאכלים טריים, דגים, ירקות ועוגיות מסורתיות.',
          },
        ],
      },
      food: {
        heading: 'אוכל בקאנאזאווה',
        description:
          'המטבח המקומי בקאנאזאווה מתמקד באורז איכותי, דגים טריים ומנות מסורתיות.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468169/Grill-Otsuka-01_hlbo9c.jpg',
            title: 'אורז הנטון',
            text: 'האורז המשובח של העיר, מרכיב מרכזי במטבח המקומי.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468287/cuisine019sushi-B-feature_hlbcvc.avif',
            title: 'אין מידע זמין',
            text: 'אין מידע זמין',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1741872704/placeholder.jpg',
            title: 'אין מידע זמין',
            text: 'אין מידע זמין',
          },
        ],
      },
      nightlife: {
        heading: 'בילוי בקאנאזאווה',
        description:
          'קאנאזאווה מהווה מקור השראה עם אווירה היסטורית ונוסטלגית המשולבת בסדרות אנימה.',
        cards: [
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468558/ep08-20m51s_mqtp2j.png',
            title: 'קאנאזאווה מהווה מקור השראה',
            text: 'העיר והאזור עם הארכיטקטורה המסורתית והמורשת של הסמוראים נראים פעמים רבות באנימה כאווירה של עבר.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468584/r01_qk2pj6.webp',
            title: 'השראת העיר בסדרות אנימה',
            text: 'רובע הסמוראים והגנים המוריקים מהווים תפאורה לסדרות היסטוריות ואנימה עם אווירה מסתורית.',
          },
          {
            image:
              'https://res.cloudinary.com/drejchdwh/image/upload/v1742468613/ep21-06m22s_jdk9tt.png',
            title: 'נפלאות השוק בסדרות אנימה',
            text: 'השוק הייחודי של קאנאזאווה משמש דימוי מקורי במנגות ובאנימה של מאכלים מסורתיים ומפגשים תרבותיים.',
          },
        ],
      },
    },
  },
]

// רכיבי חיצים מותאמים לשימוש ב-react-slick (מופיעים רק בגרסת LG)
function NextArrow(props) {
  const { style, onClick } = props
  return (
    <button
      style={{
        ...style,
        background: 'transparent',
        border: 'none',
      }}
      onClick={onClick}
      className="hidden lg:block"
    >
      <ArrowLeft />
    </button>
  )
}

function PrevArrow(props) {
  const { style, onClick } = props
  return (
    <button
      style={{
        ...style,
        background: 'transparent',
        border: 'none',
      }}
      onClick={onClick}
      className="hidden lg:block"
    >
      <ArrowRight />
    </button>
  )
}

// רכיב הקרוסלה עם react-slick, בגישה של Mobile First:
// במובייל יוצג קלף אחד, ב-md 2 וב-lg 3.
// עבור המובייל, נוודא שהקלף יתפוס את כל הרוחב.
function CardsSlider({ cards }, ref) {
  const settings = {
    infinite: true,
    dots: false,
    arrows: false, // החיצים ינוהלו מחוץ לקרוסלה
    speed: 500,
    slidesToShow: 3, // בגרסת LG
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 1 },
      },
    ],
  }

  return (
    <div className="relative w-[380px] md:w-full">
      <Slider ref={ref} {...settings}>
        {cards.map((card, index) => (
          <div key={index} className="px-2">
            <div
              className="relative w-full md:max-w-[436px] h-[550px] overflow-hidden mx-auto"
              style={{
                borderImage: `url(${images.redBorder}) 10 stretch`,
                borderWidth: '2px',
                borderStyle: 'solid',
              }}
            >
              <img
                className="absolute inset-0 w-full h-full object-cover"
                src={card.image}
                alt={card.title}
              />
              <div className="absolute bottom-[-40px] w-full">
                <BlackBlock />
                <div className="absolute bottom-10 flex flex-col gap-4 p-6 z-10 w-full text-right">
                  <h3 className="text-2xl text-primary">{card.title}</h3>
                  <p className="text-sm text-white">{card.text}</p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  )
}
const ForwardedCardsSlider = React.forwardRef(CardsSlider)

export function CityInfo() {
  const [selectedCity, setSelectedCity] = useState(cities[0])
  const sliderRefs = {
    destinations: useRef(null),
    food: useRef(null),
    nightlife: useRef(null),
  }

  const handleCityChange = (city) => {
    setSelectedCity(city)
  }

  const handlePrev = (sectionKey) => {
    sliderRefs[sectionKey].current.slickPrev()
  }
  const handleNext = (sectionKey) => {
    sliderRefs[sectionKey].current.slickNext()
  }

  return (
    <section className="container mx-auto">
      {/* מפת יפן */}
      <div className="relative my-[200px] lg:my-[50px] inline-block mb-8">
        <div className="absolute right-[-20px] lg:right-[-80px] top-[-60px]">
          <ChooseCityBanner />
        </div>
        <img
          src={japanImages.japanmap}
          alt="Japan map"
          title="Japan map"
          className="w-full"
        />
        {cities.map((city) => (
          <button
            key={city.name}
            onClick={() => handleCityChange(city)}
            style={{
              left: city.x,
              top: city.y,
              transform: 'translate(-50%, -50%)',
            }}
            className={`absolute border-0 cursor-pointer  ${
              selectedCity.name === city.name
                ? 'text-primary text-2xl '
                : 'text-white'
            }`}
          >
            <img className="w-4 h-4" src={dotloader} alt="Loading" />
            {city.name}
          </button>
        ))}
      </div>

      {/* סקשנים: יעדים, אוכל, בילוי */}
      {['destinations', 'food', 'nightlife'].map((sectionKey) => {
        const section = selectedCity.sections[sectionKey]
        return (
          <div key={sectionKey} className="my-16 container mx-auto">
            <div className="flex justify-between items-center">
              <div onClick={() => handleNext(sectionKey)}>
                <PrevArrow />
              </div>
              <h3 className="text-4xl text-white">{section.heading}</h3>
              <div onClick={() => handlePrev(sectionKey)}>
                <NextArrow />
              </div>
            </div>
            <p className="text-white text-center w-full mb-10">
              {section.description}
            </p>
            <div className="w-full">
              <ForwardedCardsSlider
                cards={section.cards}
                ref={(el) => (sliderRefs[sectionKey].current = el)}
              />
            </div>
          </div>
        )
      })}

      {/* ניווט לערים */}
      <div className="flex justify-center items-center flex-wrap my-[150px] gap-4 text-white">
        {cities.map((city) => (
          <button
            key={city.name}
            onClick={() => handleCityChange(city)}
            className={
              city.name === selectedCity.name ? 'text-primary text-3xl' : ''
            }
          >
            {city.name}
          </button>
        ))}
      </div>
    </section>
  )
}
